module.exports = __webpack_public_path__ + "img/infostock_fake_news_check.b46ca8f.png";